(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waitlist-screen"] && !Shopify.designMode) return;
  try {
    (function () {
    function enhanceSelect(field) {
      var select = field.querySelector('.waitlist__select');
      if (!select || field.dataset.enhanced) return;

      var placeholderText = select.options.length ? select.options[0].textContent.trim() : 'Select';
      var options = [];
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        if (o.value === '') continue;
        options.push({ value: o.value, label: o.textContent.trim() });
      }
      if (!options.length) return;

      field.dataset.enhanced = 'true';
      field.classList.add('is-enhanced');

      // The native <select> is hidden once enhanced. A hidden `required` control
      // blocks native form submission ("not focusable"), so move the required
      // check into our own submit handler (see bind()).
      if (select.hasAttribute('required')) {
        field.dataset.required = 'true';
        select.removeAttribute('required');
      }

      var cbx = document.createElement('div');
      cbx.className = 'wl-cbx';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'wl-cbx__trigger wl-cbx__trigger--placeholder';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      var label = document.createElement('span');
      label.className = 'wl-cbx__label';
      label.textContent = placeholderText;

      var chevron = document.createElement('span');
      chevron.className = 'wl-cbx__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      trigger.appendChild(label);
      trigger.appendChild(chevron);

      var panel = document.createElement('div');
      panel.className = 'wl-cbx__panel';

      var searchWrap = document.createElement('div');
      searchWrap.className = 'wl-cbx__search-wrap';
      var search = document.createElement('input');
      search.type = 'text';
      search.className = 'wl-cbx__search';
      search.setAttribute('placeholder', 'Search country');
      search.setAttribute('aria-label', 'Search country');
      search.autocomplete = 'off';
      searchWrap.appendChild(search);

      var list = document.createElement('ul');
      list.className = 'wl-cbx__list';
      list.setAttribute('role', 'listbox');

      panel.appendChild(searchWrap);
      panel.appendChild(list);
      cbx.appendChild(trigger);
      cbx.appendChild(panel);
      field.appendChild(cbx);

      var filtered = options.slice();
      var activeIndex = -1;

      function renderList() {
        list.innerHTML = '';
        if (!filtered.length) {
          var empty = document.createElement('li');
          empty.className = 'wl-cbx__empty';
          empty.textContent = 'No matches';
          list.appendChild(empty);
          return;
        }
        filtered.forEach(function (opt, idx) {
          var li = document.createElement('li');
          li.className = 'wl-cbx__option' + (idx === activeIndex ? ' is-active' : '');
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', select.value === opt.value ? 'true' : 'false');
          li.textContent = opt.label;
          li.addEventListener('mousedown', function (e) {
            e.preventDefault();
            choose(opt);
          });
          list.appendChild(li);
        });
      }

      function updateTrigger() {
        if (select.value) {
          var match = options.filter(function (o) { return o.value === select.value; })[0];
          label.textContent = match ? match.label : placeholderText;
          trigger.classList.remove('wl-cbx__trigger--placeholder');
        } else {
          label.textContent = placeholderText;
          trigger.classList.add('wl-cbx__trigger--placeholder');
        }
      }

      function scrollActive() {
        var el = list.children[activeIndex];
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      }

      function reposition() {
        var r = trigger.getBoundingClientRect();
        panel.style.left = r.left + 'px';
        panel.style.width = r.width + 'px';
        var below = window.innerHeight - r.bottom - 12;
        var above = r.top - 12;
        if (below >= 240 || below >= above) {
          panel.style.top = (r.bottom + 6) + 'px';
          panel.style.bottom = 'auto';
          list.style.maxHeight = Math.max(120, Math.min(244, below - 72)) + 'px';
        } else {
          panel.style.top = 'auto';
          panel.style.bottom = (window.innerHeight - r.top + 6) + 'px';
          list.style.maxHeight = Math.max(120, Math.min(244, above - 72)) + 'px';
        }
      }

      function onDocClick(e) {
        if (!cbx.contains(e.target)) close();
      }

      function open() {
        if (panel.classList.contains('is-open')) return;
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        search.value = '';
        filtered = options.slice();
        activeIndex = -1;
        for (var i = 0; i < filtered.length; i++) {
          if (filtered[i].value === select.value) { activeIndex = i; break; }
        }
        renderList();
        reposition();
        scrollActive();
        setTimeout(function () { search.focus(); }, 0);
        document.addEventListener('click', onDocClick, true);
        window.addEventListener('resize', reposition);
        window.addEventListener('scroll', reposition, true);
      }

      function close() {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onDocClick, true);
        window.removeEventListener('resize', reposition);
        window.removeEventListener('scroll', reposition, true);
      }

      function choose(opt) {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        field.classList.remove('is-invalid');
        updateTrigger();
        close();
        trigger.focus();
      }

      trigger.addEventListener('click', function () {
        panel.classList.contains('is-open') ? close() : open();
      });

      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        filtered = q ? options.filter(function (o) { return o.label.toLowerCase().indexOf(q) !== -1; }) : options.slice();
        activeIndex = filtered.length ? 0 : -1;
        renderList();
      });

      search.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex = Math.min(activeIndex + 1, filtered.length - 1);
          renderList();
          scrollActive();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          renderList();
          scrollActive();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (filtered[activeIndex]) choose(filtered[activeIndex]);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          close();
          trigger.focus();
        }
      });

      select.addEventListener('change', updateTrigger);
      updateTrigger();
    }

    function bind(form) {
      if (form.dataset.submitBound) return;
      form.dataset.submitBound = 'true';

      // IMPORTANT: this handler does NOT call e.preventDefault() on the happy path.
      // The form submits natively so Shopify's own form processing + bot/spam
      // protection run and the customer record is actually created. (An earlier
      // AJAX/fetch version was being silently dropped by the spam protection, so
      // the page showed "success" while no customer was saved.)
      form.addEventListener('submit', function (e) {
        var selField = form.querySelector('.waitlist__field--select');
        var sel = selField ? selField.querySelector('.waitlist__select') : null;

        // Validate the enhanced country field (its native `required` was removed
        // in enhanceSelect so the hidden <select> can't block native submit).
        if (selField && selField.dataset.required === 'true' && sel && !sel.value) {
          e.preventDefault();
          selField.classList.add('is-invalid');
          var trigger = selField.querySelector('.wl-cbx__trigger');
          if (trigger) trigger.focus();
          return;
        }

        // Fold the selected country into the customer tags so it is saved on the
        // customer and stays filterable in Shopify admin (the customer form does
        // not persist a free-text note).
        var tagsInput = form.querySelector('[data-waitlist-tags]');
        if (tagsInput) {
          var base = tagsInput.dataset.baseTag || tagsInput.value;
          tagsInput.value = (sel && sel.value) ? (base + ', ' + sel.value) : base;
        }
      });
    }

    function init() {
      if (document.querySelector('.waitlist')) {
        document.documentElement.classList.add('wl-lock');
        // Insurance: on desktop, never let focusing a waitlist field scroll the page
        // (the source of the spacing "jump"). Restores scroll position on the next frame.
        if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) {
          document.addEventListener('focusin', function (e) {
            if (!e.target || !e.target.closest || !e.target.closest('.waitlist')) return;
            var x = window.scrollX, y = window.scrollY;
            var se = document.scrollingElement;
            var st = se ? se.scrollTop : 0, sl = se ? se.scrollLeft : 0;
            requestAnimationFrame(function () {
              if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
              if (se && (se.scrollTop !== st || se.scrollLeft !== sl)) { se.scrollTop = st; se.scrollLeft = sl; }
            });
          });
        }
      }
      var selFields = document.querySelectorAll('.waitlist__field--select');
      for (var i = 0; i < selFields.length; i++) enhanceSelect(selFields[i]);
      var forms = document.querySelectorAll('.waitlist__form');
      for (var k = 0; k < forms.length; k++) bind(forms[k]);
      neutralizeCaptchaJump();
    }

    // When Shopify's invisible spam-protection injects content into the form (on the
    // first real interaction), the form grows a few px. With the vertically-centered
    // layout that would shift everything. Fix: pull the privacy note up by exactly the
    // form's growth, so the new content fills the existing gap and NOTHING moves — the
    // block stays centered and the text below the button doesn't glitch. No pre-warm
    // (which caused a visible 1s-after-load reflow), no reserved padding.
    function neutralizeCaptchaJump() {
      if (!(window.matchMedia && window.matchMedia('(min-width: 750px)').matches)) return;
      var form = document.querySelector('.waitlist__form');
      var privacy = document.querySelector('.waitlist__privacy');
      if (!form || !privacy) return;
      var baseH = form.offsetHeight;
      var apply = function () {
        var grow = form.offsetHeight - baseH;
        if (grow < 0) grow = 0;
        if (grow > 48) grow = 48;
        privacy.style.marginTop = grow ? ('-' + grow + 'px') : '';
      };
      var mo = new MutationObserver(function () { requestAnimationFrame(apply); });
      mo.observe(form, { childList: true, subtree: true });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
